import type { AxiosPromise } from 'axios'
import request from '@core/request'

/**
 * 用户信息
 * @returns {AxiosPromise}
 */
export function getAccountInfo(): AxiosPromise {
  return request({
    method: 'get',
    baseURL: `${process.env.VUE_APP_TCLOUD_BASE_API}`,
    url: '/tcloud-account/account/getAccountInfo',
  })
}

// 查看营业执照,实名认证,购买产品等是否过期
export function getAuthenticationStatus(): AxiosPromise {
  return request({
    method: 'get',
    baseURL: `${process.env.VUE_APP_TCLOUD_BASE_API}`,
    url: '/tcloud-account/authentication/getAuthenticationStatus',
  })
}

export function getAccountStatus(): AxiosPromise {
  return request({
    method: 'get',
    baseURL: `${process.env.VUE_APP_TCLOUD_BASE_API}`,
    url: '/tcloud-account/account/getAccountStatus',
  })
}

export function getAuthInfoByAuth(): AxiosPromise {
  return request({
    method: 'get',
    baseURL: `${process.env.VUE_APP_API}`,
    url: '/tcloud-media-cube/promotionGroup/getAccountInfo',
  })
}

export function logoutAcc() {
  return request({
    baseURL: `${process.env.VUE_APP_TCLOUD_BASE_API}`,
    url: '/tcloud-sso/account/logout',
    method: 'post',
    data: {},
  })
}

// 腾讯云生成临时秘钥接口
export function getCOSToken(): AxiosPromise {
  return request({
    url: '/cos/sts',
    method: 'get',
  })
}

export interface EquityNumType {
  accountId: string // 账户ID
  count: number // 总数
  surplus: number // 剩余额度
  purchase: 1 | 0 // 0 未存在有效权益 1 存在有效权益
}
// 评估剩余额度
export function assessResidualEquityNum(): AxiosPromise<{ [T in 603 | 605]: EquityNumType }> {
  return request({
    url: '/assess/residualEquityNum',
    method: 'get',
  })
}
// 获取省市区
export function listGeologyTree(): AxiosPromise<{ [T in 603 | 605]: EquityNumType }> {
  return request({
    baseURL: `${process.env.VUE_APP_TCLOUD_BASE_API}`,
    url: '/tcloud-component/geology/listGeologyTree',
    method: 'get',
  })
}
// 获取用户当前使用产品
export function getCurrentProduct(): AxiosPromise<{ productId: 605 | 628 | null }> {
  return request({
    url: '/geoAccount/getCurrentProduct',
    method: 'get',
  })
}

// 更新用户当前使用产品
export function updateProductConfig(data: { productId: 605 | 628 }): AxiosPromise {
  return request({
    url: '/geoAccount/updateProductConfig',
    method: 'post',
    data,
  })
}
export function functionalRights(): AxiosPromise<any> {
  return request({
    url: '/dataCenter/functionalRights',
    method: 'get',
    errorMessageShow: false,
  })
}
